const statuses = [
  {
    id: 'null',
    name: 'На рассмотрении',
  },
  {
    id: '1',
    name: 'Согласовано',
  },
  {
    id: '0',
    name: 'Отклонено',
  },
];

export function getOperatorStatuses() {
  return statuses;
}

export function getOperatorStatusById(id) {
  return statuses.find((x) => x.id === id);
}

export function getOperatorStatusName(val) {
  if (val === null) {
    return 'На рассмотрении';
  }
  return val ? 'Согласовано' : 'Отклонено';
}
